import React from 'react';
import { Link } from 'react-router-dom';
import { homeHeroAnimation, homeHeroGems } from './homePage.data';
import './HomeHero.scss';

const HomeHero = () => (
  <section
    className="home-hero"
    aria-labelledby="home-hero-title"
    style={{ '--home-hero-background': `url(${homeHeroGems})` } as React.CSSProperties}
  >
    <video
      className="home-hero__video"
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      poster={homeHeroGems}
      aria-hidden="true"
    >
      <source
        src={homeHeroAnimation}
        type="video/mp4"
        media="(min-width: 861px) and (prefers-reduced-motion: no-preference)"
      />
    </video>
    <div className="home-hero__copy">
      <p className="home-eyebrow">TrueKarat Jewelry</p>
      <h1 id="home-hero-title">Shop jewelry by collection</h1>
      <p>Explore products by type, filter by gender, or open the full catalog.</p>
      <div className="home-hero__actions">
        <Link to="/products" className="home-primary-link">
          Browse all jewelry
        </Link>
        <a href="#shop-by-type-title" className="home-secondary-link">
          Shop by type
        </a>
      </div>
    </div>
  </section>
);

export default HomeHero;
